// Contested-cell stroke ring. A thin flat quad-ring traced just inside
// and outside the attacked cell's edges. Stroke only, no fill. So the
// defend / intercept prompt has an unmissable "look here" anchor on the
// board without painting over the cell's contents. Geometry is emitted
// directly in world space from sampleCellGeometry's corner quad, so it
// follows skewed grid cells exactly and reads the same from any angle.
import * as THREE from 'three';

const OUTER_SCALE = 1.015;
const INNER_SCALE = 0.96;

function ringPositions(cellGeo, y) {
  const corners = [cellGeo.tl, cellGeo.tr, cellGeo.br, cellGeo.bl];
  const cx = (cellGeo.tl.x + cellGeo.tr.x + cellGeo.br.x + cellGeo.bl.x) / 4;
  const cz = (cellGeo.tl.z + cellGeo.tr.z + cellGeo.br.z + cellGeo.bl.z) / 4;
  const scaled = (p, s) => ({ x: cx + (p.x - cx) * s, z: cz + (p.z - cz) * s });
  const outer = corners.map((p) => scaled(p, OUTER_SCALE));
  const inner = corners.map((p) => scaled(p, INNER_SCALE));
  // Two triangles per side: outer[i], outer[i+1], inner[i] / inner[i],
  // outer[i+1], inner[i+1].
  const pos = [];
  for (let i = 0; i < 4; i++) {
    const j = (i + 1) % 4;
    pos.push(
      outer[i].x, y, outer[i].z, outer[j].x, y, outer[j].z, inner[i].x, y, inner[i].z,
      inner[i].x, y, inner[i].z, outer[j].x, y, outer[j].z, inner[j].x, y, inner[j].z,
    );
  }
  return new Float32Array(pos);
}

export function createContestedCellRing(cellGeo, { y = 0.24, color = 0xe8c36e } = {}) {
  const geo = new THREE.BufferGeometry();
  geo.setAttribute('position', new THREE.BufferAttribute(ringPositions(cellGeo, y), 3));
  const mat = new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity: 0.55,
    side: THREE.DoubleSide,
    depthWrite: false,
  });
  const mesh = new THREE.Mesh(geo, mat);
  // Below every card (cards hover above the playmat) but above the
  // playmat texture. Same band the harbinger circles use at rest.
  mesh.renderOrder = -80;
  return mesh;
}

export function disposeContestedCellRing(mesh) {
  if (!mesh) return;
  mesh.geometry?.dispose();
  mesh.material?.dispose();
}
